import { DropDownBox, DropDownBoxLayoutStyle } from '@apply/components';
import { FileTypeOption } from '../../../constants/loanFile';

interface FileTypeFieldProps {
    id: string;
    value: number | null;
    onChange: (fileTypeId: number | null) => void;
    /** The types offered, in the order shown. */
    options: FileTypeOption[];
}

/** The type the next added files are given. */
export const FileTypeField = ({ id, value, onChange, options }: FileTypeFieldProps) => {
    return (
        <DropDownBox
            id={id}
            value={value}
            onChange={onChange}
            label='File Type'
            dataSource={options}
            displayExpr='name'
            valueExpr='id'
            placeholder='Select'
            width='100%'
            height='36px'
            layoutStyle={DropDownBoxLayoutStyle.Horizontal}
            labelWidth='100px'
        />
    );
};
